import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-title-underline" }, "すべてのピックアップ動画", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 視聴履歴はありませんでした。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_category_list_content = _resolveComponent("video-category-list-content")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_ctx.toArray(_ctx.videoCategories).length)
              ? (_openBlock(), _createBlock(_component_video_category_list_content, {
                  key: 0,
                  videoCategories: _ctx.videoCategories
                }, null, 8, ["videoCategories"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_3
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}